import React, {useState} from 'react'
import {useTranslation} from "react-i18next";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import moment from "moment";
import MDTypography from "../../../components/MDTypography";
import MDBox from "../../../components/MDBox";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import {Collapse} from "@mui/material";
import {useDispatch} from "react-redux";
import {onErrorAlert, onSuccessAlert} from "../../../actions";
import Tooltip from "@mui/material/Tooltip";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import UserCarrierEdit from "../../profile/userInformation/UserCarrierEdit";
import EditIcon from "@mui/icons-material/Edit";
import {cargoOwnerInfo} from "../../../actions/inventory/inventoryAction";
import LocalStorage from "../../../utils/LocalStorage";
import {checkPermission, PERMISSION_DICT} from "../../../utils/Users_Roles_Permission";
import {userWHMpCfgInfo} from "../../../actions/userWHMp/userWHMpAction";

const OwnerCargoInfo = ({info,setOpenCarrierEdit,loading,setOpenStorageFeeTermEdit}) => {

    const [isOpen,setIsOpen] = useState(true)
    const {t} = useTranslation()
    const dispatch = useDispatch()

    const handleClickCopy = (textToCopy) => {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(textToCopy)
                .then(() => {
                    dispatch(onSuccessAlert(`"${textToCopy}" ${t('copied')}`))
                })
                .catch((err) => {
                    dispatch(onErrorAlert(`${t('copy failed')}`))
                });
        }

    };
    const activeArr = [
        {
            id: 1,
            value: 'Y',
            label: `${t(`ProductPage.OPEN`)}`
        },
        {
            id: 2,
            value: 'N',
            label: `${t(`ProductPage.CLOSED`)}`
        },
        {
            id: 3,
            value: 'C',
            label: `${t(`ProductPage.CREATED`)}`
        },

    ]

    const storageFeePaymentTermArr = [
        {
            id: 1,
            value: '1',
            label: `${t(`Monthly`)}`
        },
        {
            id: 2,
            value: '2',
            label: `${t('Weekly')}`
        },


    ]


    return(<React.Fragment>
        <Card  sx={{minWidth: 350}}>
            <MDBox
                mx={1}
                mt={-3}
                py={1}
                px={2}
                variant="gradient"
                bgColor="light"
                borderRadius="lg"
                coloredShadow="light"
                display={'flex'}
                alignItems={'center'}
                justifyContent={'space-between'}

            >
                <MDTypography variant="h6">
                    {t('CustomerPage.Cargo Owner Basic Information')}
                </MDTypography>
                <IconButton color={'white'}  disabled={loading}  size={'small'} onClick={()=>setIsOpen(!isOpen)}>
                    {(isOpen && !loading)?<Icon>expand_less</Icon>:<Icon>expand_more</Icon>}
                </IconButton>
            </MDBox>
            <Collapse in={isOpen&& !loading} timeout={500}>
                <MDBox pt={1} pb={2} px={2}>
                    <Grid container xs={12} display="flex" p={0} m={0}>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.User Name')}:
                                </MDTypography>
                                {info?.userName && info?.userName!=='NOT PROVIDED' && <Tooltip title="copy" placement={'right'} onClick={()=> handleClickCopy(info?.userName)}>
                                    <IconButton aria-label="copy" size="small" color="primary">
                                        <ContentCopyIcon fontSize="small"/>
                                    </IconButton>
                                </Tooltip> }
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.userName}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.OCP Owner ID')}:
                                </MDTypography>
                                {info?.ocpOwnerId && info?.ocpOwnerId!=='NOT PROVIDED' && <Tooltip title="copy" placement={'right'} onClick={()=> handleClickCopy(info?.ocpOwnerId)}>
                                    <IconButton aria-label="copy" size="small" color="primary">
                                        <ContentCopyIcon fontSize="small"/>
                                    </IconButton>
                                </Tooltip> }
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.ocpOwnerId}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.OMS Owner ID')}:
                                </MDTypography>
                                {info?.omsOwnerId && info?.omsOwnerId!=='NOT PROVIDED' && <Tooltip title="copy" placement={'right'} onClick={()=> handleClickCopy(info?.omsOwnerId)}>
                                    <IconButton aria-label="copy" size="small" color="primary">
                                        <ContentCopyIcon fontSize="small"/>
                                    </IconButton>
                                </Tooltip> }
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.omsOwnerId}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.Lot ID')}:
                                </MDTypography>
                                {info?.lotId && info?.lotId!=='NOT PROVIDED' && <Tooltip title="copy" placement={'right'} onClick={()=> handleClickCopy(info?.lotId)}>
                                    <IconButton aria-label="copy" size="small" color="primary">
                                        <ContentCopyIcon fontSize="small"/>
                                    </IconButton>
                                </Tooltip> }
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.lotId}
                                </MDTypography>
                            </MDBox>
                        </Grid>


                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom>
                                    {t('CustomerPage.Alternative ID')}:
                                </MDTypography>
                                {info?.alternativeId && info?.alternativeId!=='NOT PROVIDED' && <Tooltip title="copy" placement={'right'} onClick={()=> handleClickCopy(info?.alternativeId)}>
                                    <IconButton aria-label="copy" size="small" color="primary">
                                        <ContentCopyIcon fontSize="small"/>
                                    </IconButton>
                                </Tooltip> }
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.alternativeId}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.OMS Owner Type')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.omsOwnerType}
                                </MDTypography>
                            </MDBox>
                        </Grid>

                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.Payment Term')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.paymentTerm}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.Invoice Term')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.invoiceTerm}
                                </MDTypography>
                            </MDBox>
                        </Grid>

                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.Account Manager')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.accountManager}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('SignUpPage.Company Name')}:
                                </MDTypography>
                                {info?.companyName && info?.companyName!=='NOT PROVIDED' && <Tooltip title="copy" placement={'right'} onClick={()=> handleClickCopy(info?.companyName)}>
                                    <IconButton aria-label="copy" size="small" color="primary">
                                        <ContentCopyIcon fontSize="small"/>
                                    </IconButton>
                                </Tooltip> }
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.companyName}
                                </MDTypography>
                            </MDBox>
                        </Grid>

                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.Allow Split Order')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.allowSplitOrder === 'N'?"NO":info?.allowSplitOrder === 'Y'?"YES":''}
                                </MDTypography>
                            </MDBox>
                        </Grid>



                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.Financer Email')}:
                                </MDTypography>
                                {info?.financerEmail && info?.financerEmail!=='NOT PROVIDED' && <Tooltip title="copy" placement={'right'} onClick={()=> handleClickCopy(info?.financerEmail)}>
                                    <IconButton aria-label="copy" size="small" color="primary">
                                        <ContentCopyIcon fontSize="small"/>
                                    </IconButton>
                                </Tooltip> }
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.financerEmail}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.Solution Rank')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.solutionRank}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.Consumption Amount')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.consumptionAmount}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.Current Version')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.currentVersion}
                                </MDTypography>
                            </MDBox>
                        </Grid>

                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.Note Text')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.noteText}
                                </MDTypography>
                            </MDBox>
                        </Grid>

                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom>
                                    {t('CustomerPage.Description 1')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.ownerDesc1}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.Description 2')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.ownerDesc2}
                                </MDTypography>
                            </MDBox>
                        </Grid>

                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.Carriers')}:
                                </MDTypography>
                            </MDBox>
                            {checkPermission(PERMISSION_DICT.CustomerCargoInfo) &&
                                <MDBox
                                style={{cursor: "pointer", alignItems: "center",width: "100px",}}
                                onClick={() => {
                                    dispatch(cargoOwnerInfo({ ownerId: info?.ocpOwnerId,
                                        userName: LocalStorage.getItem('username')}))

                                    setOpenCarrierEdit(true)
                                }}
                            >

                                    <MDTypography variant="button" fontWeight="regular" color="primary">
                                    &nbsp;{t('CustomerPage.View Details')}
                                </MDTypography>
                            </MDBox>}
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.Storage Fee Term')}:
                                </MDTypography>
                            </MDBox>
                            {
                                // checkPermission(PERMISSION_DICT.CustomerCargoInfo) &&
                                <MDBox
                                >
                                    <MDBox sx={{
                                        display: "flex",
                                        fontSize: "15px",
                                        cursor: "pointer",
                                        alignItems: "center",
                                        width: "80px",
                                    }}
                                           onClick={() => {
                                               // dispatch(cargoOwnerInfo({ ownerId: info?.ocpOwnerId,
                                               //     userName: LocalStorage.getItem('username')}))
                                               //
                                               if (checkPermission(PERMISSION_DICT.CustomerCargoStorageFeeTermModify))
                                               {
                                                   setOpenStorageFeeTermEdit(true)
                                               }
                                           }}
                                    >
                                        <MDTypography variant="button" fontWeight="regular" color="primary">
                                            {/*{storageFeePaymentTermArr.find((e)=>e.value===info?.storageFeeTerm)?.label}*/}
                                            {storageFeePaymentTermArr.find((e)=>e.value===info?.storageFeeTerm)?storageFeePaymentTermArr.find((e)=>e.value===info?.storageFeeTerm).label:storageFeePaymentTermArr[0].label}
                                        </MDTypography>
                                        {
                                            checkPermission(PERMISSION_DICT.CustomerCargoStorageFeeTermModify)&& <Icon>edit</Icon>
                                        }
                                    </MDBox>
                                </MDBox>}
                        </Grid>
                    </Grid>
                </MDBox>
            </Collapse>
        </Card>

    </React.Fragment>)
}

export default OwnerCargoInfo